import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";

function Tooltip({ message }) {
  return (
    <>
      <span className={ 'tooltip' }
            data-tip={ message }>i</span>
      <ReactTooltip event={ 'mouseover' }
                    eventOff={ 'mouseleave' }
                    delayShow={ 250 }
                    delayHide={ 150 }
                    clickable={ true }
      />
    </>
  );
}

Tooltip.propTypes = {
  event: PropTypes.string,
  message: PropTypes.string.isRequired,
}

export default Tooltip;
